import React from 'react';

import { createClassName } from 'utils/createClassName';

import './smallPressControlStyles.scss';

type Props = {
  disabled?: boolean;
  onPress(): void;
};

export const SmallPressControlComponent: React.FC<Props> = (props) => {
  const { onPress, children } = props;

  const className = createClassName('smallPressControl')();

  return (
    <button className={className} type="button" onClick={onPress}>
      {children}
    </button>
  );
};
